<section *ngIf="_userType && _accessToken" class="login text-center">
    <div>
        <div class="container-inner mb-6">
            <div class="px-3 py-3 w-100">
                <div class="col d-flex justify-content-between align-items-center login-head">
                    <img src="assets/images/logo.svg" alt="">
                    <app-support-help></app-support-help>
                </div>
            </div>
        </div>
        <div class="login-content-wrapper mx-auto login-content-wrapper-pricing">

            <div class="heading-with-back-arrow upgrade-section">
                <div class="d-flex align-items-center mb-0 w-100">
                    <div class="w-100 d-flex back-annual-heading">
                        <div class="back-annual-plan upgrade-icon">
                            <span (click)="onRedirectToUsertype()" class="material-icons">
                                keyboard_backspace
                            </span>
                        </div>
                        <p class="heading text-center w-100 mb-4">
                            <ng-container *ngIf="_userType == eUserType.SHIPPER || _userType == eUserType.FINANCIAL_ADMIN">Select a Shipper Subscription Plan</ng-container>
                            <ng-container *ngIf="_userType == eUserType.CARRIER  || _userType == eUserType.CARRIER_FINANCIAL_ADMIN">Select a Carrier Subscription Plan</ng-container>
                            <ng-container *ngIf="_userType == eUserType.OWNER_OPERATOR">Select an Owner Operator Subscription Plan</ng-container>
                        </p>

                    </div>
                </div>

            </div>

        </div>

        <div class="login-content box_shodow plan-content">
            <!-- Subscription Package -->
            <div class="select_plan_page">
                <div class="select_plan_list">
                  <div class="plan_box selected_plan position-relative" *ngFor="let iPlan of _subscriptionPlans">
    
                    <div class="corner-ribbon top-right sticky orange" *ngIf="iPlan.id == current">
                        Current
                    </div>

                    <h3 class="heading3">
                        {{ iPlan.interval == 'year' ? 'Annual Plan' : 'Monthly Plan' }}
                    </h3>

                    <div>
                        <span class="value">
                        {{ iPlan.amount | currency:(iPlan.currency | uppercase):'symbol':'1.2-2' }}
                        <sub>/{{ iPlan.interval }}</sub>
                        </span>
                    </div>

                    <button *ngIf="iPlan.id == current"
                            mat-button
                            class="btn large_btn rounded_btn green_btn"
                            (click)="getPlanDetails(iPlan.id)">
                        Renew Plan
                    </button>

                    <button *ngIf="iPlan.id != current"
                            mat-button
                            class="btn large_btn rounded_btn green_btn"
                            (click)="getPlanDetails(iPlan.id)">
                        Switch and Renew
                    </button>

                    </div>
                </div>
            </div>
            <!-- //Subscription Package -->
        </div>

    </div>
</section>